import { PipeTransform, Pipe } from "@angular/core";
import { UserInterface } from "@core/interfaces/user.interface";
import { UserService } from "@core/services/user.service";

@Pipe({
  name: "isForumModerator"
})
export class IsForumModeratorPipe implements PipeTransform {
  constructor(public readonly userService: UserService) {}

  transform(user: UserInterface | null, args?: any): boolean {
    if (!user) {
      return false;
    }
    return this.userService.isInGroup(user, "forum_moderators");
  }
}
